import { render } from "./DocCustomer.vue?vue&type=template&id=1b389f54&scoped=true&ts=true"
import script from "./DocCustomer.vue?vue&type=script&lang=ts"
export * from "./DocCustomer.vue?vue&type=script&lang=ts"

import "./DocCustomer.vue?vue&type=style&index=0&id=1b389f54&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b389f54"]])

export default __exports__